/*
 * Zgoda na cookies/analitykę — dwie kategorie: niezbędne (zawsze aktywne,
 * bez wyboru — sesyjny identyfikator logowania w local storage) i "Analityka
 * i marketing" (Google Ads + TikTok Ads + Contentsquare, razem, opt-in).
 *
 * Google Ads (gtag.js) ładuje się ZAWSZE, w public/index.html, w Consent Mode v2
 * (tryb zaawansowany): bez zgody wysyła tylko pingi bez cookies. Tutaj tylko
 * przekazujemy mu wybór z banera (gtag consent update). TikTok Pixel (ttq.js)
 * i Contentsquare ładują się dopiero stąd, po realnej zgodzie, nigdy wcześniej.
 */

const KEY = "prawly:cookie-consent"; // "granted" | "denied"

export function getConsent() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "granted" ? true : v === "denied" ? false : null;
  } catch {
    return null;
  }
}

/** Jedna kategoria w banerze → wszystkie cztery sygnały Consent Mode. */
function updateGoogleConsent(granted) {
  const v = granted ? "granted" : "denied";
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: v,
      ad_user_data: v,
      ad_personalization: v,
      analytics_storage: v,
    });
  }
}

export function setConsent(granted) {
  try {
    localStorage.setItem(KEY, granted ? "granted" : "denied");
  } catch {
    /* prywatne okno / zablokowany storage — zgoda po prostu nie przetrwa odświeżenia */
  }
  updateGoogleConsent(granted); // przed czymkolwiek innym — to ono steruje ciasteczkami Google
  if (granted) loadAnalyticsScripts();
}

/** Do linku "Ustawienia cookies" w stopce — pokazuje baner ponownie. */
export function resetConsent() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* jw. */
  }
  window.dispatchEvent(new Event("prawly:consent-reset"));
}

let loaded = false;

export function loadAnalyticsScripts() {
  if (loaded) return;
  loaded = true;

  // TikTok Pixel — kod bazowy z TikTok Ads Manager, bez zmian poza stylem
  // (ttq to publiczny identyfikator pikselowy, nie sekret). Uzupełnia serwerowe zdarzenia z tiktokCapi.js
  // (ten sam event_id = deduplikacja po stronie TikToka), patrz CaseDetail.jsx.
  (function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    ttq.methods = [
      "page", "track", "identify", "instances", "debug", "on", "off", "once",
      "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent",
      "revokeConsent", "grantConsent",
    ];
    ttq.setAndDefer = function (t, e) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) {
      var e = ttq._i[t] || [];
      for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
      return e;
    };
    ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {};
      ttq._i[e] = [];
      ttq._i[e]._u = r;
      ttq._t = ttq._t || {};
      ttq._t[e] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[e] = n || {};
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = r + "?sdkid=" + e + "&lib=" + t;
      var f = document.getElementsByTagName("script")[0];
      f.parentNode.insertBefore(s, f);
    };
    ttq.load("DAT2V8RC77U5PB60D9G0");
    ttq.page();
  })(window, document, "ttq");

  // Contentsquare
  const csScript = document.createElement("script");
  csScript.async = true;
  csScript.src = "https://t.contentsquare.net/uxa/b79ea6c5eb89f.js";
  document.head.appendChild(csScript);
}
